/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { getSchedule } from '@/app/services/rooms/roomsschedules';
import * as Actions from '@/app/store/actions';
import { convertTimeTo12HourFormat } from '@/utils/utils';
import {
	Avatar,
	CircularProgress,
	IconButton,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Popover,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Deleteconfirmschedule from './Deleteconfirmschedule';
import './roomspage.css';
import PageHeader from '@/app/customComponents/PageHeader';
import GradientButton from '@shared/components/GradientButton';
import { PlusIcon, DocumentArrowUpIcon } from '@heroicons/react/24/outline';
import { useNavigate, useLocation } from 'react-router-dom';

const Roomsschedules = () => {
	const dispatch = useDispatch();
	const [rows, setRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [hasMore, setHasMore] = useState(false);
	const [firstLoad, setFirstLoad] = useState(true);
	const [fetchingMore, setFetchingMore] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const [page, setPage] = useState(1);
	const [activeTab, setActiveTab] = useState(0);
	const user = useSelector(({ auth }) => auth.user);
	const [anchorEl, setAnchorEl] = useState(null);
	const navigate = useNavigate();
	const location = useLocation();
	const { id } = useParams();
	const { row } = location.state;

	const handledelete = (row) => {
		dispatch(
			Actions.openDialog({
				children: <Deleteconfirmschedule refresh={refresh} row={row} setRefresh={setRefresh} />,
			})
		);
	};

	useEffect(() => {
		let isMounted = true;
		const timeout = setTimeout(
			() => {
				if (!isMounted) return;
				setIsLoading(true);
				getSchedule(id, user.school?.id || user.data?.school?.id, 1)
					.then((res) => {
						if (!isMounted) return;
						setFirstLoad(false);
						setRows(res.data.data);
						setHasMore(res.data.to < res.data.total);
						setPage(res.data.current_page + 1);
					})
					.catch(() => {
						if (!isMounted) return;
						dispatch(
							Actions.showMessage({
								message: 'Failed to fetch data, please refresh',
								variant: 'error',
							})
						);
					})
					.finally(() => {
						if (!isMounted) return;
						setIsLoading(false);
					});
			},
			firstLoad ? 0 : 1000
		);
		return () => {
			isMounted = false;
			clearTimeout(timeout);
		};
	}, [refresh]);

	const handleLoadMore = () => {
		setFetchingMore(true);
		getSchedule(id, user.school?.id || user.data?.school?.id, page)
			.then((res) => {
				if (res.data.last_page > res.data.current_page) {
					setHasMore(true);
				} else {
					setHasMore(false);
				}
				setPage(res.data.current_page + 1);
				setRows(rows.concat(res.data.data));
				setFetchingMore(false);
			})
			.catch(() => {
				setFetchingMore(false);
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			});
	};

	const handleGoBack = () => {
		navigate(-1);
	};

	const handleButtonClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSingleSchedule = () => {
		navigate(`/rooms-addschedules/${row?.id}`, { state: row });
		handleClose();
	};

	const handleGoToUploadSchedules = () => {
		navigate('/rooms-upload-schedules/');
		handleClose();
	};

	return (
		<>
			<div className="top-bar">
				<div className="flex mx-auto" style={{ gap: 20 }}>
					<span
						className="cursor-pointer personal-hd  font-semibold text-1xl mr-30 ml-40"
						onClick={() => {
							setActiveTab(0);
							navigate(`/rooms-room/${id}`, { state: { row } });
						}}
					>
						<h1 className={`${activeTab === 0 ? 'active-room-hd' : ''} room-hd`}>Students</h1>
					</span>
					<span
						className="cursor-pointer personal-hd text-1xl font-semibold"
						onClick={() => {
							setActiveTab(1);
							navigate(`/rooms-room/${id}`, { state: { row, feeds: true } });
						}}
					>
						<h1 className={`${activeTab === 1 ? 'active-room-hd' : ''} room-hd`}>Feeds</h1>
					</span>
				</div>
			</div>
			<div className="px-64 py-60 mb-64">
				<div className="flex items-center flex-nowrap justify-between">
					<PageHeader onBack={handleGoBack} title="Schedules" />
					<div className="flex items-center gap-16">
						<GradientButton onClick={handleButtonClick} variant="tertiary" size="small">
							<PlusIcon className="size-16" /> Add Schedules
						</GradientButton>

						<Popover
							anchorEl={anchorEl}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'right',
							}}
							onClose={handleClose}
							open={Boolean(anchorEl)}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'right',
							}}
						>
							<div className="py-8 bg-white rounded-md shadow-lg">
								<button
									className="w-full px-16 py-8 text-left hover:bg-gray-100 flex items-center gap-8"
									onClick={handleSingleSchedule}
									type="button"
								>
									<PlusIcon className="size-16" />
									<span>Add Single Schedule</span>
								</button>
								<button
									className="w-full px-16 py-8 text-left hover:bg-gray-100 flex items-center gap-8"
									onClick={handleGoToUploadSchedules}
									type="button"
								>
									<DocumentArrowUpIcon className="size-16" />
									<span>Upload Schedules</span>
								</button>
							</div>
						</Popover>
					</div>
				</div>
				<TableContainer
					className="bg-white p-60 mt-20 rounded-12 shadow-lg h-[60vh]"
					component={Paper}
					id="Scrollable-table"
				>
					<Table className="student-table" stickyHeader style={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
									Start Time
								</TableCell>
								<TableCell className="bg-white studentTableHeader" style={{ width: '15%' }}>
									End Time
								</TableCell>
								<TableCell className="bg-white studentTableHeader approve-hd " style={{ width: '25%' }}>
									Subject
								</TableCell>
								<TableCell className="bg-white studentTableHeader approve-hd " style={{ width: '30%' }}>
									Activity Type
								</TableCell>
								<TableCell className="bg-white studentTableHeader approve-hd " style={{ width: '15%' }}>
									Action
								</TableCell>
							</TableRow>
						</TableHead>

						<TableBody className="">
							{isLoading ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : !rows.length && !firstLoad ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										No Schedules
									</TableCell>
								</TableRow>
							) : (
								rows?.map((row) => (
									<TableRow key={row.id}>
										<TableCell component="th" scope="row" style={{ fontWeight: 700 }}>
											<div className="flex ">
												<div className="flex flex-col items-start">
													<div className="truncate break-word std-name">
														{/* {moment.utc(row.start_time).local().format('LT')} */}
														{convertTimeTo12HourFormat(row.start_time)}
													</div>
												</div>
											</div>
										</TableCell>
										<TableCell component="th" scope="row" style={{ fontWeight: 700 }}>
											<div className="flex ">
												<div className="flex flex-col items-start">
													<div className="truncate break-word std-name">{convertTimeTo12HourFormat(row.end_time)}</div>
												</div>
											</div>
										</TableCell>
										<TableCell style={{ fontWeight: 700 }}>
											<div className="flex items-center">
												<Avatar src={row.thumb} style={{ width: 30, height: 30 }} />
												<div className="name-subject break-word">{row.subject}</div>
											</div>
										</TableCell>
										<TableCell style={{ fontWeight: 700 }}>
											<div className="schedule-type break-word">{row.type}</div>
										</TableCell>
										<TableCell component="th" scope="row" style={{ fontWeight: 700 }}>
											<IconButton
												onClick={() => {
													navigate(`/rooms-updateschedule/${row.id}`, { state: { row } });
												}}
												size="small"
											>
												<img alt="edit" src="assets/images/circle-edit.png" width="25px" />
											</IconButton>
											<IconButton onClick={() => handledelete(row)} size="small">
												<img alt="edit" src="assets/images/dlt.png" width="25px" />
											</IconButton>
										</TableCell>
									</TableRow>
								))
							)}
							{fetchingMore ? (
								<TableRow>
									<TableCell align="center" colSpan={8}>
										<CircularProgress size={35} />
									</TableCell>
								</TableRow>
							) : null}
							<TableRow className="table-activity">
								<TableCell className="full-row " colSpan={5}>
									<div className="addactivty-btn">
										<button
											type="button"
											onClick={() => {
												navigate(`/rooms-addschedules/${row?.id}`, { state: row });
											}}
											style={{ cursor: 'pointer' }}
										>
											<img alt="add-icon" src="assets/images/add.png" />
											<p>+ Add Activity</p>
										</button>
									</div>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
				<InfiniteScroll
					dataLength={rows.length}
					hasMore={hasMore}
					next={handleLoadMore}
					scrollableTarget="Scrollable-table"
				/>
			</div>
		</>
	);
};
export default Roomsschedules;
